/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/InStorePickup/InStorePickup.Forms',[], function () {
	'use strict';

	// Forms fields configuration for data validation
	var forms = {
		searchStores: {
			Fields: [
                {
                	"Name": 'Zip/Postal Code',
                	"Field": '#isp-search-zip',
                	"Param": 'zip',
                	"Type": 'Text',
                	"Validators": [
                        {
                        	"Type": 'Zip',
                        	"ReferencedField": '#isp-search-country'
                        }
                	]
                },
				{
					"Name": 'ProductId',
					"Field": '#isp-search-productId',
					"Param": 'productId',
					"Type": 'Hidden'
				}
			],
			Validate: true
		}
	};

	return forms;
});
